import { Ogp } from "shared/features/utils";
import { NextPageWithLayout } from "shared/types";

import { StandardLayout } from "~/components";
import { PasswordNewPage } from "~/features/users";

const Page: NextPageWithLayout = () => {
  return (
    <>
      <Ogp title="パスワード再設定" />
      <PasswordNewPage />
    </>
  );
};

Page.getLayout = (page) => {
  return <StandardLayout>{page}</StandardLayout>;
};

export default Page;
